import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const createQuestionSet = (readingId, passage, data) =>
  apiClient.post(ENDPOINTS.READING.CREATE_QUESTION_SET(readingId, passage), data);

export const updateQuestionSet = (readingId, passage, questionSetId, data) =>
  apiClient.put(ENDPOINTS.READING.UPDATE_QUESTION_SET(readingId, passage, questionSetId), data);

export const deleteQuestionSet = (readingId, passage, questionSetId) =>
  apiClient.delete(ENDPOINTS.READING.DELETE_QUESTION_SET(readingId, passage, questionSetId));

export const getAllQuestionSets = (readingId, passage) =>
  apiClient.get(ENDPOINTS.READING.QUESTION_SETS(readingId, passage));

export const getQuestionSetById = (readingId, passage, questionSetId) =>
  apiClient.get(ENDPOINTS.READING.QUESTION_SET(readingId, passage, questionSetId));
